import React, { Fragment } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { IconButton } from "@mui/material";
import { BiUpArrowAlt, BiDownArrowAlt } from "react-icons/bi";
import { RequestStatus } from "../constants/RequestStatus";
import StyledChip from "../components/elements/StyledChip";
import {
  Data,
  HeaderCellStyle,
  StyledTableWrapper,
} from "../components/styled/StyledTable.styled";
import {
  PositiveAction,
  NegativeAction,
  ActionWrapper,
} from "../components/styled/ModelPermission.styled";
import Loader from "./elements/Loader";

function ModelPermissionTableHead(props) {
  const { headCells, order, setOrder } = props;
  const handleChangeSort = (id) => {
    setOrder({ id: id, sort: order.sort === "asc" ? "dsc" : "asc" });
  };
  const handleChangeId = (id) => {
    setOrder({ id: id, sort: "asc" });
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell, index) => (
          <TableCell
            key={index}
            align={"center"}
            sx={{ width: "fit-content", padding: "10px" }}
          >
            <HeaderCellStyle>
              {headCell.label}
              {headCell.sorting && (
                <Fragment>
                  {order.id === headCell.id ? (
                    <IconButton
                      onClick={() => {
                        handleChangeSort(headCell.id);
                      }}
                    >
                      {order.sort === "asc" && (
                        <BiUpArrowAlt
                          style={{
                            fontSize: "14px",
                            color: "black",
                          }}
                        />
                      )}
                      {order.sort === "dsc" && (
                        <BiDownArrowAlt
                          style={{
                            fontSize: "14px",
                            color: "black",
                          }}
                        />
                      )}
                    </IconButton>
                  ) : (
                    <IconButton
                      onClick={() => {
                        handleChangeId(headCell.id);
                      }}
                    >
                      <BiUpArrowAlt
                        style={{
                          fontSize: "14px",
                          opacity: "0.5",
                        }}
                      />
                    </IconButton>
                  )}
                </Fragment>
              )}
            </HeaderCellStyle>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export default function ModelPermissionTable({
  headCells,
  rows,
  order,
  setOrder,
  loading,
  chips,
  onClickAction,
  ...props
}) {
  const getChipColorBasedOnRequestStatus = (status) => {
    if (status === RequestStatus.APPROVED) {
      return "success";
    }
    if (status === RequestStatus.REJECTED) {
      return "error";
    }
    return "";
  };

  return (
    <StyledTableWrapper>
      <TableContainer>
        <Table
          sx={{ minWidth: "100px", padding: "10px" }}
          aria-labelledby="tableTitle"
        >
          {loading ? (
            <>
              <Loader />
            </>
          ) : (
            <>
              <ModelPermissionTableHead
                headCells={headCells}
                order={order}
                setOrder={setOrder}
              />
              <TableBody>
                {rows.map((row, index) => {
                  const labelId = `enhanced-table-row-${index}`;
                  return (
                    <TableRow key={labelId} hover>
                      {Object.keys(row).map((key) => {
                        if (key === "id") {
                          return null;
                        } else if (key === chips) {
                          if (
                            row[key] === RequestStatus.APPROVED ||
                            row[key] === RequestStatus.REJECTED
                          ) {
                            return (
                              <TableCell
                                align={"left"}
                                sx={{
                                  maxWidth: "200px",
                                  minWidth: "80px",
                                  overflowWrap: "break-word",
                                }}
                              >
                                <StyledChip
                                  label={row[key]}
                                  color={getChipColorBasedOnRequestStatus(
                                    row[key]
                                  )}
                                />
                              </TableCell>
                            );
                          } else
                            return (
                              <TableCell>
                                <ActionWrapper>
                                  <PositiveAction
                                    onClick={() => {
                                      onClickAction({
                                        data: row,
                                        type: RequestStatus.APPROVED,
                                      });
                                    }}
                                    data-testid="ModelPermissionTable-apprve-btn-test"
                                  >
                                    Approve
                                  </PositiveAction>
                                  |
                                  <NegativeAction
                                    onClick={() => {
                                      onClickAction({
                                        data: row,
                                        type: RequestStatus.REJECTED,
                                      });
                                    }}
                                    data-testid="ModelPermissionTable-reject-btn-test"
                                  >
                                    Reject
                                  </NegativeAction>
                                </ActionWrapper>
                              </TableCell>
                            );
                        } else {
                          return (
                            <TableCell align={"center"}>
                              <Data>{!row[key] ? "N/A" : row[key]}</Data>
                            </TableCell>
                          );
                        }
                      })}
                    </TableRow>
                  );
                })}
              </TableBody>
            </>
          )}
        </Table>
      </TableContainer>
    </StyledTableWrapper>
  );
}
